import React from 'react'
import {Swiper,SwiperSlide} from 'swiper/react'
import { Autoplay, Navigation,Pagination } from 'swiper';

import './SwiperStruct.css';

const SwiperStruct = (props) => {
  return (
    <>
            <div className="roadmap_container">
            <div className="">
            <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={12}
                autoplay={props.auto}
                slidesPerView={props.spv1}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
            >
                <SwiperSlide className='swiperstruct_slides'>
                    <a href={(props.rsrc1)} ><img src={props.img1 ? props.img1 : "img/Roadmap/comingsoon.webp"} alt={props.alt1} loading="lazy" /></a>
                    <h2>{props.rm1}</h2>
                </SwiperSlide>
                
                <SwiperSlide className='swiperstruct_slides'>
                    <a href = {(props.rsrc2)}><img src={props.img2 ? props.img2 : "image/RoadMap/comingsoon.webp"} alt={props.alt2} loading="lazy" /></a>                    
                    <h2>{props.rm2}</h2>
                </SwiperSlide>

                <SwiperSlide className='swiperstruct_slides'>
                    <a href = {(props.rsrc3)}><img src={props.img3 ? props.img3 : "image/RoadMap/comingsoon.webp" } alt={props.alt3} loading="lazy" /></a> 
                    <h2>{props.rm3}</h2>
                </SwiperSlide>

                <SwiperSlide className='swiperstruct_slides'>
                    <a href = {(props.rsrc4)}><img src={props.img4 ? props.img4 : "image/RoadMap/comingsoon.webp" } alt={props.alt4} loading="lazy" /></a> 
                    <h2>{props.rm4}</h2>
                </SwiperSlide>

                <SwiperSlide className='swiperstruct_slides'>
                    <a href = {(props.rsrc5)}><img src={props.img5 ? props.img5 : "image/RoadMap/comingsoon.webp" } alt={props.alt5}  loading="lazy" /></a> 
                    <h2>{props.rm5}</h2>
                </SwiperSlide>

                <SwiperSlide className='swiperstruct_slides'>
                    <a href = {(props.rsrc6)}><img src={props.img6 ? props.img6 : "image/RoadMap/comingsoon.webp" } alt={props.alt6} loading="lazy" /></a> 
                    <h2>{props.rm6}</h2>
                </SwiperSlide>

                <SwiperSlide className='swiperstruct_slides'>
                    <a href = {(props.rsrc7)}><img src={props.img7 ? props.img7 : "image/RoadMap/comingsoon.webp" } alt={props.alt7} loading="lazy" /></a> 
                    <h2>{props.rm7}</h2>
                </SwiperSlide>

                <SwiperSlide className='swiperstruct_slides'>
                    <a href = {(props.rsrc8)}><img src={props.img8 ? props.img8 : "image/RoadMap/comingsoon.webp" } alt={props.alt8} loading="lazy" /></a> 
                    <h2>{props.rm}</h2>
                </SwiperSlide>

            </Swiper>
            </div>
        </div>
    
    
    </>
  )
}

export default SwiperStruct